import { PageFilter } from '../state/app';
import { Customer, CustomerListFilter } from '../state/customer';
import axios from '../utils/axios';

const baseUrl = `/api/customers`;

export const fetchCustomerList = async ({
  filters,
  paging,
}: {
  filters: CustomerListFilter;
  paging: PageFilter;
}) => {
  const params = new URLSearchParams();
  params.append('cacheBuster', new Date().getTime().toString());
  params.append('pageSize', paging.pageSize.toString());
  params.append('pageNumber', paging.pageNumber.toString());

  Object.entries(filters).forEach(([key, value]) => {
    params.append(key, value);
  });

  const requestUrl = `${baseUrl}`;
  return await axios.get(`${requestUrl}?${params.toString()}`);
};

export const fetchCustomer = async (id: Customer['id']) => {
  const requestUrl = `${baseUrl}/${id}`;
  return await axios.get(requestUrl);
};

export const createCustomer = async (customer: Customer) => {
  const requestUrl = `${baseUrl}`;
  return await axios.post(requestUrl, customer);
};

export const updateCustomer = async (customer: Customer) => {
  const requestUrl = `${baseUrl}`;
  return await axios.put(requestUrl, customer);
};
